export function getParameterByName(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.search);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
}

export function getToken() {
  const parts = location.pathname.split("/").filter((v) => v);
  return parts[0];
}

export function config() {
  const isDev = window.location.host.includes("epistle.test");
  return {
    dev: isDev,
    functionsUrl: isDev ? "http://functions.epistle.test:9124" : "https://functions.epistle.org",
    epistleApiUrlHttp: isDev ? "http://test.epistle.test:3020" : "https://api.epistle.org",
    apiUrl: isDev ? "http://localhost:9127" : "",
  }
}

export function sleep(time) {
  return new Promise((resolve) => {
    setTimeout(resolve, time);
  });
}
